
import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar';

@Component({
  selector: 'lib-clinician-app-bar',
  standalone: true,
  imports: [MatButton, MatToolbar, MatToolbarRow],
  templateUrl: './clinician-app-bar.component.html',
  styleUrl: './clinician-app-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClinicianAppBarComponent {
  public logout = output();
}
